module.exports = __webpack_public_path__ + "media/images/fit_1-298f929ccf33c3848b52422b1d6f13de.png";